import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import Icon from 'common/Icons/Icon';
import Button from 'components/lib/Button';
import Dropdown from 'components/lib/Dropdown';
import PillSwitcher from 'components/lib/PillSwitcher';
import { CmiDigestWatchlistRun } from 'types/cmiDigestWatchlist';

import { stripWeekdayFromPeriodLabel } from './helpers';

const VISIBLE_RUNS_COUNT = 4;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

const Label = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--dark-blue);
  font-size: 12px;
`;

const BoldLabel = styled.span`
  font-family: var(--font-bold);
`;

type Props = {
  runs: CmiDigestWatchlistRun[];
  selectedRunId: number | null;
  onSelect: (runId: number) => void;
};

const DigestSelector = ({ runs, selectedRunId, onSelect }: Props) => {
  const visibleRuns = runs.slice(0, VISIBLE_RUNS_COUNT);
  const earlierRuns = runs.slice(VISIBLE_RUNS_COUNT);
  const selectedEarlierRun = earlierRuns.find((run) => run.id === selectedRunId);

  const pillItems = visibleRuns.map((run) => ({ key: run.id, label: stripWeekdayFromPeriodLabel(run.period_label) }));

  const earlierItems = earlierRuns.map((run) => ({
    key: String(run.id),
    label: `${run.frequency_label} · ${run.period_label}`,
    onClick: () => onSelect(run.id),
  }));

  return (
    <Row>
      <PillSwitcher items={pillItems} activeKey={selectedRunId ?? -1} onChange={onSelect} />
      {earlierRuns.length > 0 && (
        <Dropdown menu={{ items: earlierItems }} trigger={['click']}>
          <span style={{ display: 'inline-block' }}>
            <Button className={classNames('dropdown', { active: Boolean(selectedEarlierRun) })} style={{ height: 28 }}>
              <Label>
                <BoldLabel>Earlier Weeks:</BoldLabel>
                {selectedEarlierRun ? selectedEarlierRun.period_label : 'Select'}
                <Icon src="/icons/dropdown-caret-down-blue.svg" />
              </Label>
            </Button>
          </span>
        </Dropdown>
      )}
    </Row>
  );
};

export default DigestSelector;
